import React from "react";
import { Button } from "./Button.styles";
type ButtonProps = {
  onClick: () => void;
  children?: React.ReactNode;
};
export const MuiButton: React.FC<ButtonProps> = ({
  onClick,
  children,
}: ButtonProps) => {
  return <Button onClick={onClick}>{children || "Connection"}</Button>;
};
export default MuiButton;
